import Overview from "../../template/pages/Documentation/pages/Overview/Overview"
import Licences from "../../template/pages/Documentation/pages/Licences/Licences"
import QuickStart from "../../template/pages/Documentation/pages/QuickStart/QuickStart"
import Charts from "../../template/pages/Documentation/pages/Charts/Charts"
import Forms from "../../template/pages/Documentation/pages/Forms/Forms"
import UI from "../../template/pages/Documentation/pages/UI/UI"
import Maps from "../../template/pages/Documentation/pages/Maps/Maps"
import Tables from "../../template/pages/Documentation/pages/Tables/Tables"
import Structure from "../../template/pages/Documentation/pages/Structure/Structure"
import Libs from "../../template/pages/Documentation/pages/Libs/Libs"

const docLayoutRoutes = [
    {
        path: "overview",
        name: "Overview",
        component: Overview
    },
    {
        path: "licences",
        name: "Licences",
        component: Licences
    },
    {
        path: "quick-start",
        name: "QuickStart",
        component: QuickStart
    },
    {
        path: "charts",
        name: "Charts",
        component: Charts
    },
    {
        path: "forms",
        name: "Forms",
        component: Forms
    },
    {
        path: "ui",
        name: "UI",
        component: UI
    },
    {
        path: "maps",
        name: "Maps",
        component: Maps
    },
    {
        path: "tables",
        name: "DocTables",
        component: Tables
    },
    {
        path: "structure",
        name: "Structure",
        component: Structure
    },
    {
        path: "Libs",
        name: "Libs",
        component: Libs
    }
]

export default docLayoutRoutes